import React from "react";
import { cn } from "../../lib/utils";

const Badge = ({ children, className }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full border border-zinc-800 bg-zinc-900 px-2.5 py-0.5 text-xs font-semibold text-zinc-100 transition-colors hover:bg-zinc-800 focus:outline-none focus:ring-2 focus:ring-zinc-400 focus:ring-offset-2",
      className
    )}
  >
    {children}
  </span>
);

export default Badge;

